module.exports = __webpack_public_path__ + "static/media/Sharp-LS027B7DH01A-Mechanical-Drawing.74c7cb10.png";